import Fetch from "./Fetch";
import { handleError, handleResponse } from "./ApiUtils";

import { API_BASIC_URL_SLOT_SERVICE } from "../config/constants";

export const fetchAllCountries = () => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/countries`).then(handleResponse).catch(handleError);
};

export const fetchAllRegions = (countryCode) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/${countryCode}`).then(handleResponse).catch(handleError);
};

export const fetchAllAreas = (countryCode) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/${countryCode}/regions/areas`).then(handleResponse).catch(handleError);
};

export const fetchServiceInActiveStatusByCountryId = (countryCode) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/country/service/${countryCode}`).then(handleResponse).catch(handleError);
};
